import { render, staticRenderFns } from "./cbc.vue?vue&type=template&id=d97aaaa0"
import script from "./cbc.vue?vue&type=script&lang=js"
export * from "./cbc.vue?vue&type=script&lang=js"
import style0 from "./cbc.vue?vue&type=style&index=0&id=d97aaaa0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports